import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Login.module.css";
import logo from "../../assets/logo.png";
import Swal from "sweetalert2";
import api from "../../utils/axiosConfig";
import { API_ENDPOINTS } from "../../utils/apiConfig";
import { AuthContext } from "../../context/AuthContext";

const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [pw, setPw] = useState("");
  const navigate = useNavigate();
  const { dispatch } = useContext(AuthContext);

  const disabled = username.trim().length === 0 || pw.trim().length === 0;

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await api.post(API_ENDPOINTS.login, {
        username,
        password: pw,
      });

      const h = res.headers as Record<string, string | undefined>;
      const access =
        h["authorization"] ?? (h as any)["Authorization"];
      const refresh =
        h["refresh-token"] ?? (h as any)["Refresh-Token"];

      if (!access) {
        throw new Error("로그인 응답에 access 토큰이 없습니다.");
      }

      dispatch({
        type: "LOGIN",
        accessToken: String(access),
        refreshToken: refresh ? String(refresh) : undefined,
      });

      navigate("/dashboard", { replace: true });
    } catch (err: any) {
      console.error(err?.message ?? "로그인 실패");
      Swal.fire({
        icon: "error",
        title: "로그인 실패",
        text: "이메일 또는 비밀번호를 확인해 주세요.",
      });
    }
  };

  useEffect(() => {
    const KEY = "authRedirectMessage";
    try {
      const msg = sessionStorage.getItem(KEY);
      if (msg) {
        Swal.fire({
          icon: "info",
          title: "알림",
          text: msg,
        });
        sessionStorage.removeItem(KEY);
      }
    } catch {}
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <img src={logo} alt="일상돌봄플랫폼 관리자 페이지 로고" className={styles.logo} />
        <h1 className={styles.title}>일상돌봄플랫폼 관리자 페이지</h1>

        <form className={styles.form} onSubmit={onSubmit}>
          <label className={styles.label}>아이디</label>
          <input
            className={styles.input}
            type="text"
            placeholder=""
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
          />

          <label className={styles.label}>비밀번호</label>
          <input
            className={styles.input}
            type="password"
            placeholder=""
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            autoComplete="current-password"
          />

          <button
            type="submit"
            disabled={disabled}
            className={styles.button}
          >
            로그인
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;